import './ThrobberLoading.css'; 

const ThrobberLoading = () => {
  return (
      <div className="spinner"></div>
  );
};

export default ThrobberLoading;
